import React, { useState, useRef, useEffect } from 'react';
import { Field, Form, Formik } from 'formik';
import { fullForm } from '../validations';
import { saveItem, getExistingData } from '../helper';
import { FetchExpressWizard } from '../types';
import FormikMaskedInput from '../../CommonComponents/FormikMaskedInput';
import { currencyMask, numberMask } from '../../CommonComponents/MaskedInput';

interface Props {
  fetchExpressWizard: FetchExpressWizard;
  retirementAge: string;
}

const FormMenu: React.FC<Props> = ({ fetchExpressWizard, retirementAge }) => {
  const [isOpen, seIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLLIElement>(null);

  const handleClickOutside = event => {
    if (isOpen && wrapperRef && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      seIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <ul
      className="menu"
      id="ExpressWizard_Menu"
      onMouseEnter={event => {
        event.stopPropagation();
        seIsOpen(true);
      }}
      onClick={event => {
        event.stopPropagation();
        seIsOpen(true);
      }}
    >
      <li className={`user ${isOpen ? 'hover' : ''}`} ref={wrapperRef}>
        <i className="fa fa-user"></i>
        <i className="fa fa-caret-down"></i>
        <ul
          className="user_dropdown"
          onMouseLeave={event => {
            event.stopPropagation();
            seIsOpen(false);
          }}
        >
          <li className="head">Plan Assumptions</li>
          <>
            <Formik
              initialValues={getExistingData()}
              validationSchema={fullForm}
              onSubmit={values => {
                saveItem(values);
                fetchExpressWizard(values, retirementAge);
              }}
              render={({ errors, touched }) => {
                return (
                  <Form>
                    <li>
                      <label>Your Age</label>
                      <div
                        className={`input ${
                          errors.CurrentAge && touched.CurrentAge ? 'invalid' : ''
                        }`}
                      >
                        <Field
                          name="CurrentAge"
                          component={FormikMaskedInput}
                          mask={numberMask}
                          placeholder="0"
                          maxLength="2"
                          style={{ width: '60px' }}
                        />
                      </div>
                    </li>
                    <li>
                      <label>Spouse's Age</label>
                      <div
                        className={`input ${
                          errors.SpouseCurrentAge && touched.SpouseCurrentAge ? 'invalid' : ''
                        }`}
                      >
                        <Field
                          name="SpouseCurrentAge"
                          component={FormikMaskedInput}
                          mask={currencyMask}
                          placeholder="0"
                          maxLength="2"
                          style={{ width: '60px' }}
                        />
                      </div>
                    </li>
                    <li>
                      <label>Annual Household Income</label>
                      <div
                        className={`input ${
                          errors.HouseholdIncome && touched.HouseholdIncome ? 'invalid' : ''
                        }`}
                      >
                        <i style={{ marginRight: '5px' }}>$</i>
                        <Field
                          name="HouseholdIncome"
                          component={FormikMaskedInput}
                          mask={currencyMask}
                          placeholder="0"
                          style={{ width: '65px' }}
                          className="input-container"
                        />
                      </div>
                    </li>
                    <li>
                      <label>Monthly Expenses</label>
                      <div
                        className={`input ${
                          errors.MonthlyExpense && touched.MonthlyExpense ? 'invalid' : ''
                        }`}
                      >
                        <i style={{ marginRight: '5px' }}>$</i>
                        <Field
                          name="MonthlyExpense"
                          component={FormikMaskedInput}
                          mask={currencyMask}
                          placeholder="0"
                          style={{ width: '65px' }}
                          className="input-container"
                        />
                      </div>
                    </li>
                    <li>
                      <label>Monthly Retirement Savings</label>
                      <div
                        className={`input ${errors.MonthlyRetirementSavings &&
                          touched.MonthlyRetirementSavings &&
                          'invalid'}`}
                      >
                        <i style={{ marginRight: '5px' }}>$</i>
                        <Field
                          name="MonthlyRetirementSavings"
                          component={FormikMaskedInput}
                          mask={currencyMask}
                          placeholder="0"
                          style={{ width: '65px' }}
                          className="input-container"
                        />
                      </div>
                    </li>

                    <li>
                      <label>Total Retirement Savings</label>
                      <div
                        className={`input ${errors.TotalRetirementSavings &&
                          touched.TotalRetirementSavings &&
                          'invalid'}`}
                      >
                        <i style={{ marginRight: '5px' }}>$</i>
                        <Field
                          name="TotalRetirementSavings"
                          component={FormikMaskedInput}
                          mask={currencyMask}
                          placeholder="0"
                          style={{ width: '65px' }}
                          className="input-container"
                        />
                      </div>
                    </li>

                    <li className="update">
                      <button
                        type="submit"
                        className="primary flat update"
                        disabled={
                          Object.values(errors).length > 0 && Object.values(touched).length > 0
                        }
                      >
                        Update
                      </button>
                    </li>
                  </Form>
                );
              }}
            />
          </>
        </ul>
      </li>
    </ul>
  );
};

export default FormMenu;
